
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M49.486 11.14c-.1-.5-.2-.7-.3-.9-.1-.2-.3-.3-.5-.2-3.1 2-5.8 4-9.2 5.5-2.5 1.1-5 2.1-6.4 4.6-1.8 3.3-1.4 7.3 1.3 9.8-3.1 5-5.4 10.8-7.3 16-3.6-11.7-8.6-23.3-15.2-33.6-.6-1-1.2 2-.7 2.7 6.7 10.5 11.8 22.4 15.3 34.3.2.6.8 1.2 1.1.3 2.2-5.9 4.6-12.9 8.4-18.5 4.1 2.5 8.9 2.3 11.4-2.3 2.9-5.2 3-11.9 2.1-17.7zm-11.8 17.6c1.2-1.5 2.5-2.8 3.9-4 .8-.6.3-3.6-.4-3-2.1 1.7-3.9 3.7-5.5 6-1.8-1.3-3.1-3.2-1.7-5.5 1-1.6 3-2.4 4.7-3.2 3.5-1.6 6.4-3.5 9.6-5.5.8 7.4-1 19.4-10.6 15.2z"}})])
          )
        }
      }
    